import { lazy } from 'react'

export const BenefitsV1 = lazy(() => import('./BenefitsV1'))
